import React, { useState, useEffect } from 'react';
import { FormGroup, FormControl, FormLabel, Button } from 'react-bootstrap';
import classNames from 'classnames';
import ApiService from '../../services/ApiService';
import { modal } from '../modal/ModalEmitter';
import FileNotFound from '../FileNotFound';
import TagCreateForm from './TagCreateForm';

const ManageTags = ({ callback }) => {
  // TODO redux or react-query
  const [fetchingTags, setFetchingTags] = useState(true);
  const [tags, setTags] = useState([]);
  const [currentTag, setCurrentTag] = useState(null);
  const [showAdd, setShowAdd] = useState(false);

  const [editLabel, setEditLabel] = useState('');
  const [editColor, setEditColor] = useState('');

  const fetchTags = () => {
    setFetchingTags(true);
    return ApiService.get('tags')
      .then(response => {
        setTags(response.data);
      })
      .finally(() => {
        setFetchingTags(false);
      });
  };

  const handleLabelChange = event => {
    setEditLabel(event.target.value);
  };

  const handleColorChange = event => {
    setEditColor(event.target.value);
  };

  const editTag = tagId => {
    const tagToEdit = tags.find(t => t.id === tagId);

    setCurrentTag(tagId);
    setEditLabel(tagToEdit.label);
    setEditColor(tagToEdit.color || '');
  };

  const handleUpdateClick = () => {
    const payload = {
      label: editLabel,
      color: editColor,
    };

    ApiService.post(`/tag/${currentTag}`, payload).then(() => {
      fetchTags();
      if (callback) {
        callback();
      }
    });
  };

  const handleRemoveClick = () => {
    const tagToRemove = tags.find(t => t.id === currentTag);

    modal.confirm({
      message: (
        <span>
          Are you sure you want to remove tag <strong>{tagToRemove.label}</strong>?
        </span>
      ),
      callback: () => {
        ApiService.delete(`/tag/${tagToRemove.id}`).then(() => {
          setCurrentTag(null);
          fetchTags();
          if (callback) {
            callback();
          }
        });
      },
    });
  };

  const renderEditTagForm = () => {
    return (
      <>
        <FormGroup className="mb-1">
          <FormLabel>Change Label</FormLabel>
          <FormControl type="text" placeholder="Enter Label" onChange={handleLabelChange} value={editLabel} />
        </FormGroup>

        <FormGroup>
          <FormLabel>Change Color</FormLabel>
          <FormControl type="text" placeholder="Enter Color" onChange={handleColorChange} value={editColor} />
        </FormGroup>
        <Button variant="primary" block onClick={handleUpdateClick}>
          Update Tag
        </Button>
        {/* <Button variant="danger" block onClick={handleRemoveClick} disabled={!currentTag}>
          Remove Tag
        </Button> */}
      </>
    );
  };

  const onAdd = () => {
    fetchTags();
    setShowAdd(false);
  };

  useEffect(() => {
    if (tags.length && !currentTag) {
      editTag(tags[0].id);
    }
  }, [tags]);

  useEffect(() => {
    fetchTags();
  }, []);

  if (!tags.length) {
    return (
      <div className="manage-tags">
        <FileNotFound>No Tags Setup</FileNotFound>
      </div>
    );
  }

  return (
    <>
      <div className="manage-tags">
        {showAdd ? (
          <TagCreateForm onCancel={() => setShowAdd(false)} callback={onAdd} />
        ) : (
          <>
            <div className="tag-list">
              {tags.map(tag => {
                return (
                  <div
                    className={classNames('tag-item', { selected: currentTag === tag.id })}
                    key={tag.id}
                    onClick={() => editTag(tag.id)}
                  >
                    <i className="fas fa-square mr-1" style={{ color: tag.color }} /> {tag.label}
                  </div>
                );
              })}
            </div>

            <div className="tag-controls">{currentTag !== null && renderEditTagForm()}</div>
          </>
        )}
      </div>
      <div className="modal-footer d-flex justify-content-between">
        {showAdd === false ? (
          <Button className="mt-2" variant="success" onClick={() => setShowAdd(true)}>
            New Tag
          </Button>
        ) : (
          <div />
        )}

        <Button className="mt-2" variant="secondary" onClick={() => modal.close()}>
          Close
        </Button>
      </div>
    </>
  );
};

export default ManageTags;
